export class ListAuditLogRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "filters",
            "baseName": "filters",
            "type": "AuditLogFilterConditions",
            "format": ""
        },
        {
            "name": "sorts",
            "baseName": "sorts",
            "type": "Array<SortLogsBy>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListAuditLogRequest.attributeTypeMap;
    }
    constructor() {
    }
}
